import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import { Form } from "@ui/form/Form";
import Panel from "@ui/panel/Panel";
import { Rows } from "@ui/table/Rows";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { S_ADD_IBAN_POPUP } from "./AddIbanPopup";

export const S_ADD_BANK_POPUP = new Signal<{ id: number } | null>("S_ADD_BANK_POPUP");

export const AddBankPopup = () => {
	useLocale();
	const requestData = S_ADD_BANK_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const [form, setForm] = useState<IBank>();

	useEffect(() => {
		if (requestData) {
			loadBank();
		}
	}, [requestData]);

	const loadBank = async () => {
		if (requestData) {
			const res = await GD.REQ_BANK.request({
				bankID: requestData.id,
			});

			if (res?.error) {
				setError(res?.error);
			} else if (res?.data) {
				setForm(JSON.parse(JSON.stringify(res.data)));
			}
		}
	};

	if (!requestData) return null;

	const handleSubmit = async () => {
		if (form) {
			setError(undefined);
			setBusy(true);

			const res = await GD.REQ_BANK_SAVE.request(form);
			if (!res.error) {
				closePopup();
			} else {
				setError(res.error);
			}
			setBusy(false);
		}
	};

	const closePopup = () => {
		S_ADD_BANK_POPUP.invoke(null);
		setError(undefined);
		setForm(undefined);
	};

	return (
		<Panel
			sx={{
				maxWidth: "1200px",
				height: "80vh",
				padding: "0",
				minWidth: "500px",
			}}
			decorator="absolute"
			busy={busy}
			label={requestData.id === -1 ? msg("addNewBank") : msg("editBank")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "40px 20px",
					backgroundColor: "#EEF0F2",
				}}>
				<Form
					data={form}
					decorator={[
						{
							direction: "column",
							fields: [
								{
									name: "data.name",
									label: msg("bankName"),
								},
								{
									name: "data.country",
									label: msg("country"),
								},
								{
									name: "data.timezone",
									label: msg("timezone"),
								},

								// {
								// 	name: "commission",
								// 	label: "Commission",
								// },
								// {
								// 	name: "commissionPercent",
								// 	label: "Commission percent",
								// },
							],
						},
					]}
				/>

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: "8px",
					}}>
					<Button
						variant="secondarySmall"
						title={msg("addIban")}
						onClick={() => {
							if (form) {
								S_ADD_IBAN_POPUP.invoke({
									callback: (ibanNew: IIban) => {
										const ibans: IIban[] = form.data.iban ?? [];
										ibans.push(ibanNew);
										setForm({ ...form });
									},
								});
							}
						}}
					/>

					{form?.data.iban && (
						<Rows
							data={form?.data.iban}
							itemType="iban"
							order={["__itemType", "name", "iban"]}
							onClick={_row => {}}
							menu={[
								{
									id: "edit",
									title: msg("edit"),
								},
								{
									id: "delete",
									title: msg("delete"),
								},
							]}
							onMenuClick={(id, row, _innerRowID) => {
								switch (id) {
									case "edit":
										S_ADD_IBAN_POPUP.invoke({
											iban: row,
											callback: (i: IIban) => {
												row.iban = i.iban;
												row.name = i.name;
												setForm({ ...form });
											},
										});

										break;
									case "delete":
										let ibans: IIban[] | undefined = form.data.iban;
										if (ibans) {
											const index: number = ibans.indexOf(row);
											if (index >= 0) {
												ibans = ibans.splice(index, 1);
											}
											if (ibans.length === 0) {
												ibans = undefined;
											}
											setForm({ ...form });
										}

										break;
								}
							}}
							cellFactory={(_row, cell, _index, _key, name, _sx) => {
								if (
									cell === "__actions" ||
									name === "__itemType" ||
									name === "__itemOrderDivider" ||
									name === "created_at" ||
									name === "updated_at" ||
									name === "status"
								) {
									return {
										content: "",
									};
								}
								return {
									content: "",
								};
							}}
						/>
					)}
				</Box>
			</VBox>

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				<Error error={error} />
				<Button
					title={msg("submit_155f816c")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
